<template>
  <v-flex xs4 class="px-4">
    <v-card class="card-guideline px-5 py-8 rounded-24">
      <v-row class="px-3">
        <v-flex xs4>
          <img
            v-if="typeCard === 1"
            src="@/assets/images/icon/Icon-Manual.png"
            height="100px"
          />
          <img
            v-if="typeCard === 2"
            src="@/assets/images/icon/icon-video.png"
            height="100px"
          />
          <img
            v-if="typeCard === 3"
            src="@/assets/images/icon/icon-download.png"
            height="100px"
          />
        </v-flex>
        <v-flex xs8 class="pt-2">
          <span class="fs-20 font-weight-bold primary--text">{{ title }}</span>
          <p class="grey--text text--darken-1 caption" v-if="typeCard === 1">
            Form of text with pictures
          </p>
          <p class="grey--text text--darken-1 caption" v-if="typeCard === 2">
            Coming soon
          </p>
          <p class="grey--text text--darken-1 caption" v-if="typeCard === 3">
            Guideline document {{ ver }}
          </p>
          <v-layout class="pt-3">
            <v-spacer></v-spacer>
            <v-menu rounded offset-y v-if="typeCard === 3">
              <template v-slot:activator="{ on }">
                <v-btn
                  rounded
                  color="bluePurple"
                  dark
                  medium
                  class="py-4 px-7 mr-2 text-capitalize"
                  right
                  height="36px"
                  v-on="on"
                >
                  <span class="font-weight-bold button">Download</span></v-btn
                >
              </template>
              <v-list>
                <v-list-item @click="downloadDoc('id')">
                  <v-list-item-title>Indonesian Version</v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadDoc('en')">
                  <v-list-item-title>English Version</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn
              v-else
              rounded
              color="bluePurple"
              dark
              medium
              class="py-4 px-7 mr-2 text-capitalize"
              right
              height="36px"
              :to="{ name: 'content-management-text' }"
            >
              <span class="font-weight-bold button">Details</span></v-btn
            >
          </v-layout>
        </v-flex>
      </v-row>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    typeCard: {
      type: Number
    },
    ver: {
      type: String,
      required: false
    }
  },
  methods: {
    downloadDoc(docType) {
      this.$emit('download', docType);
    }
  }
};
</script>
